/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, September 27th 2022, 1:28:34 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

const { atom } = require("jotai");
const { default: LocalStorageUtils } = require("utils/LocalStorage");

const defaultLanguage = LocalStorageUtils.language.get()
const defaultDateLocale = LocalStorageUtils.dateLocale.get()

const language = atom(defaultLanguage)
const dateLocale = atom(defaultDateLocale)

const LanguageAtom = {
    language,
    dateLocale,
}

export default LanguageAtom